import { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

/**
 * Pulls from the ExperienceContext and returns all available props for components to use.
 */
export const useExperienceContext = () => {
  const context = useContext(ExperienceContext);

  const isInitialized = context !== undefined && Object.prototype.hasOwnProperty.call(context, 'clientStore');
  if (!isInitialized) {
    throw new Error(
      'useExperienceContext must be used within an ExperienceProvider',
    );
  }

  // Enable a simple responsive design. The `sm:` prefix is added to Tailwind CSS class names for non-mobile channels.
  const { channel } = context;
  const smModifierEnabled = channel !== 'mobile';

  return {
    ...context,
    isDesktop: channel === 'desktop',
    isMobile: channel === 'mobile',
    smModifierEnabled,
  };
};
